export const timelineData = [
  {
    period: "JUL-2022 - FEB-2025",
    title: "Software Engineer",
    company: "Amazon",
    description: "Redesigned critical logistics systems, reducing API load by 3M/day and boosting order closure by 50% across 110+ FCs. Improved system reliability by 80% and delivery speed by 20% through real-time monitoring and streamlined engineering processes."
  },
  {
    period: "FEB-2022 - JUL-2022",
    title: "Software Engineer",
    company: "Juspay",
    description: "Built a secure NFC tokenization SDK with Juspay and a custom ISO 8583 server for robust transaction handling. Reduced manual reporting by 40% through RESTful audit APIs."
  },
  {
    period: "SEP-2021 - FEB-2022",
    title: "Product Developer",
    company: "Inncircles",
    description:
      "Developed live E-learning platforms (500+ users) with Angular, React Native, and Express.js. Improved engagement by 30% and delivered consistent cross-platform UX across 2+ projects."
  }
];
